import AuthorisationVM from "../../Services/AuthorisationVM";

export default class CatalogueAuthorisation {
    public static authorisationVM: AuthorisationVM;
}